import { Button, Flex, Input, Form, Modal, notification } from "antd";
import React, { useState } from "react";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { prepareSmsMessage, sendEmailMessage } from "../../../service";
import { P } from "../../molecules/service-details-modal/ServiceDetailsModal";
import { colors } from "../../../styles/theme";
const { TextArea } = Input;
export const MarketingEmail: React.FC = () => {
  const { t } = useTranslation();
  const [textInput, setTextInput] = useState("");
  const [textAreaValue, setTextAreaValue] = useState("");

  const {
    mutateAsync: sendEmailMessageMutateAsync,
    isLoading: sendEmailMessageMutateIsLoading,
  } = useMutation(sendEmailMessage, {
    onSuccess: () => {
      setTextInput("");
      setTextAreaValue("");
      notification.success({
        message: t("marketingEmail.emailsSent"),
        placement: "bottomRight",
      });
    },
    onError: () => {
      notification.error({
        message: t("marketingEmail.error"),
        style: {
          background: "colors.errorBackground",
        },
        placement: "bottomRight",
      });
    },
  });

  const {
    mutateAsync: prepareSmsMessageMutateAsync,
    isLoading: prepareSmsMessageMutateIsLoading,
  } = useMutation(prepareSmsMessage, {
    onSuccess: (data) => {
      if (data?.gsm7Text?.trim()?.length === 0) {
        notification.error({
          message: t("marketingEmail.messageContentValidationError"),
          style: {
            background: "colors.errorBackground",
          },
          placement: "bottomRight",
        });
        return;
      }

      Modal.info({
        closable: true,
        title: t("marketingEmail.sendingInfoTitle"),
        onOk: () => {
          return new Promise<void>((resolve, reject) => {
            try {
              sendEmailMessageMutateAsync({
                message: JSON.stringify(data.gsm7Text)
                  .replace(/\\n/g, "<br/>")
                  .slice(1, -1),
                title: textInput,
              }).finally(() => {
                resolve();
              });
            } catch (error) {
              reject();
            }
          })
        },
        okText: t("marketingEmail.confirmSending"),
        content: (
          <Flex
            vertical
            gap={12}
            style={{
              paddingTop: "10px",
            }}
          >
            <P $height="14" $size="16" $weight="600">
              {t("marketingEmail.messageText")}
            </P>

            <div style={{ whiteSpace: "pre-line" }}>{data.gsm7Text}</div>
          </Flex>
        ),
      });
    },
    onError: () => {
      notification.error({
        message: t("marketingEmail.error"),
        style: {
          background: "colors.errorBackground",
        },
        placement: "bottomRight",
      });
    },
  });

  return (
    <>
      <div>
        <Flex justify="start" align="start" vertical>
          <h4
            style={{
              marginBottom: "0px",
            }}
          >
            {t("marketingEmail.createEmailCampaign")}
          </h4>
          <p style={{ fontSize: 14, color: "var(--color-text-secondary)", marginBottom: 15 }}>
            {t("marketingEmail.filteringNotice")}
          </p>
          <Form layout="vertical">
            <Form.Item label={t("marketingEmail.titleLabel")}>
              <Input
                style={{
                  width: "400px",
                }}
                value={textInput}
                onChange={(e) => setTextInput(e.target.value)}
              />
            </Form.Item>

            <Form.Item label={t("marketingEmail.messageLabel")}>
              <TextArea
                style={{
                  width: "400px",
                }}
                value={textAreaValue}
                onChange={(e) => setTextAreaValue(e.target.value)}
              />
            </Form.Item>
          </Form>
          <Button
            type="primary"
            onClick={() => {
              prepareSmsMessageMutateAsync({
                message: textAreaValue,
              });
            }}
            loading={
              sendEmailMessageMutateIsLoading ||
              prepareSmsMessageMutateIsLoading
            }
            disabled={
              textInput.length === 0 ||
              textAreaValue.length === 0 ||
              sendEmailMessageMutateIsLoading ||
              prepareSmsMessageMutateIsLoading
            }
          >
            {t("marketingEmail.sendEmailToClients")}
          </Button>
        </Flex>
      </div>
    </>
  );
};
